import styled from 'styled-components';

export const SearchButtonDiv = styled.div`
  padding-top: 23px;
`;
